import { render, staticRenderFns } from "./scope22.vue?vue&type=template&id=4565dfe3&scoped=true"
import script from "./scope22.vue?vue&type=script&lang=js"
export * from "./scope22.vue?vue&type=script&lang=js"
import style0 from "./scope22.vue?vue&type=style&index=0&id=4565dfe3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4565dfe3",
  null
  
)

export default component.exports